module.exports = __webpack_public_path__ + "img/ssmo.ecfedc48.jpg";